import { makeAutoObservable } from "mobx";

class LoginStore {
  email = "";
  next = "";

  constructor() {
    makeAutoObservable(this);
  }

  setEmail(email: string) {
    this.email = email;
  }

  setNext(next: string) {
    this.next = next;
  }

  clear() {
    this.email = "";
    this.next = "";
  }
}

export const loginStore = new LoginStore();
